import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import cls from 'classnames';
import styles from './ButtonContainer.less';
function ButtonContainer(props) {
    const { children, className } = props;
    return _jsx("div", { className: cls(styles.buttonGroup, className), children: children });
}
export default memo(ButtonContainer);
